/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpVmInstanceRestoreDestination } from '../models/GcpVmInstanceRestoreDestination';

export class RestoreGcpVmInstanceRequest {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': GcpVmInstanceRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "GcpVmInstanceRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreGcpVmInstanceRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

